export const byStaffMode = "byStaff";
export const byProductTypeMode = "byProductType";
export const byProductMode = "byProduct";
export const byLocationMode = "byLocation";
export const byPaymentTypeMode = "byPaymentType";
export const byPaymentMissingMode = "byPaymentMissing";
export const byOptionsMode = "byOptions";